<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content fullscreen class="video-modal-content ion-no-padding">
  <div class="video-wrapper">
    <video *ngIf="!isWebRtc"
        id="my-video"
        class="video-js vjs-default-skin"
        controls
        preload="auto"
        playsinline
        autoplay
    ></video>
    <iframe width="720" height="500" [src]="iframeUrl" frameborder="0" allowfullscreen></iframe>
    <video *ngIf="false" #localVideo autoplay muted playsinline></video>
     <!-- <video id="remoteVideo" controls autoplay playsinline width="480" height="360"></video> -->
  </div>
</ion-content>
